import { Correios } from "components/Correios";
import { Main } from "components/pages";

export default function CorreiosPage() {
  return (
    <>
      {/* <PageHeader title="Gerenciar Encomendas" /> */}

      <Main>
        <section>
          <Correios />
        </section>
      </Main>
    </>
  );
}